import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CampusDesignCategory} from '../DesignSelector/CampusDesignCategory';
import {CampusDesignCard} from '../DesignSelector/CampusDesignCard';
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';
import { MajorAccountsHdr } from '../Components/MajorAccountsHdr';
import {CampusFeedback} from './CampusFeedback';

const DIVISION: string = 'Corporate';

const categoryContainerStyle : CSSProperties = {
    position: 'relative',
    width: '200px',
    height:'500px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 15px',
    textTransform: 'uppercase',
    backgroundColor: '#E9E6E6',
    marginBottom: '15px',
    flexShrink: 0,
    borderRadius:'10px',
    marginLeft:'-100px',
};
const searchStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontFamily: 'BarlowLight',
    fontSize: '18px',
    letterSpacing: '6px',
    backgroundColor:'white',
    textAlign: 'center',
    border: '1px solid #CCCCCC',
    padding: '3px 0 3px 7px',
    textTransform: 'uppercase',
    width: '350px',
    height:'25px'
};
const smHeadStyle : CSSProperties = {
    position:'relative',
    top:'-50px',
    left:'125px',
    fontFamily:'Lulo',
    color:'#616060',
    letterSpacing:'0.15em'
};
const categoryListStyle : CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingBottom: '5px',
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: '15px',
    lineHeight: '15px',
    height:'443px',
};

const catalogStyle : CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flexGrow: 2,
    overflowY: 'auto',
};

const searchIcon: CSSProperties = {
    width:'20px',
    height:'20px'
}
const searchFormStyle: CSSProperties = {
    textAlign:'center',
    marginBottom:'0px'
}
const searchBtn: CSSProperties = {
    padding:'0px',
    backgroundImage: 'url('+ Tgcc.ResolveUrl('~/images/search_button.png') + ')',
    width: '25px',
    height: '27px',
    backgroundSize: 'cover',
    marginTop:'-28px',
    float:'right',
    marginRight:'40px',
    display:'none'
}

const contentDiv: CSSProperties = {
    display:'flex',
    margin:'20px auto 0px auto',
    width:'90%'
}
const selectedCat: CSSProperties = {
    fontFamily:'BarlowMedium',
    color:'rgb(97, 96, 96)',
    cursor:'pointer',
    fontSize:'22px',
    display:'flex',
    lineHeight:'35px',
    marginTop:'15px'
}
const addToProofBtn: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#D7D7D7',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#626262',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Lulo'
}
const clear: CSSProperties = {
    fontSize:'22px',
    width:'115px',
    lineHeight:'30px',
    height:'30px',
    backgroundColor:'rgb(226, 117, 88)',
    textAlign:'center',
    marginLeft:'15px',
    fontFamily:'AveriaSerifLight',
    letterSpacing:'1px',
    color:'white'
}
const designHdr: CSSProperties = {
    marginTop:'50px',
    fontFamily:"BarlowMedium",
    textTransform:"uppercase",
    fontSize:'25px',
    color:'rgb(97, 96, 96)',
    textAlign:'center',
}
const currentCat: CSSProperties = {
    display:'flex'
}
const inputDiv: CSSProperties = {
    marginTop:'10px',
    display:'flex',
    justifyContent:'center'
}
const cat: CSSProperties = {
    fontFamily:"AveriaSerifItalic",
    color:"black",
    marginLeft:"5px"
}
const submitButton : CSSProperties = {
        width:'125px',
        height:'30px',
        backgroundColor:'#E27558',
        margin:'5px auto 0px',
        cursor:'pointer',
        display:'none',
        textAlign:'center',
        fontFamily:"Lulo",
        color:'white',
        lineHeight:'30px',
        padding: '2px 0 2px 0px',
}
type StateType = {
    filter: string,
    category: string,
    design: Tgcc.Design,
    zoomDesign: Tgcc.Design,
    DesignCategories: string[],
    Designs: Tgcc.Design[],
    isWaiting: boolean,
}
const designCategory: string = "Featured Designs"
class _MajorAccountsDesignListView extends React.Component<Tgcc.BaseProps, any>{


 componentWillMount() {
        document.body.style.overflow = 'hidden';
        this.clearState();
        if(!this.props.state.ActiveProof){
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof()});
        }
        TgccRequest.getDesignCategories(DIVISION, (categories : string[]) => this.DesignCategoriesLoaded(categories));

        var keyword = this.props.location.query.keyword;
        if(keyword !=null){
                this.filterDesignsBySearch(keyword)
                // Prefill search box so deep links like /designs/search?keyword=CED show the active query
                setTimeout(() => {
                    var input = document.getElementById('search') as HTMLInputElement;
                    if (input) input.value = keyword;
                }, 0);
        } else{
            TgccRequest.getDesignsByCategoryFiltered(DIVISION, designCategory, null, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))
        }
    }

 componentDidMount(){
        var tag = document.getElementById('designPage');
        tag.scrollIntoView(false);
        var designCate = this.props.location.query.designCat;
        if(this.props.location.query.designCat != null)
            this.handleCategory(designCate)
        
 }
 scrollPageToView = (id: string) => {
    var el = document.getElementById(id);
    var scroller = document.getElementById("Scroller");
    scroller.scrollTop = el.offsetTop - 75;
}

    state: StateType = {
        filter: null,
        category: null,
        design: null,
        zoomDesign: null,
        DesignCategories: null,
        Designs: null,
        isWaiting: false,
    }

    clearState = () => {
        this.setState({
            filter: null,
            category: null,
            design: null,
            zoomDesign: null,
            DesignCategories: null,
            Designs: null,
            isWaiting:false});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: null})
    }

    DesignCategoriesLoaded(categories : string[]) {
        this.setState({DesignCategories: categories});
    }

    getDesignCategories() {
        var categories = new Array();
        for (var i in this.state.DesignCategories) {
            var cat: string = this.state.DesignCategories[i];
            categories.push(
                <CampusDesignCategory key={i} text={cat} onChange={this.handleFilterByCategory}></CampusDesignCategory>
            )
        };
        return categories;
    }
   
    handleFilterByCategory = (category: string) =>{
        if(category){
            TgccRequest.getDesignsByCategoryFiltered(DIVISION, category, null, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))
        }
        this.setState({category: category});
        if(this.state.isWaiting === false){
            this.setState({isWaiting:true})
        }else {
            this.setState({isWaiting:false});
        }
        var input = document.getElementById('search') as HTMLInputElement;
        input.value = '';
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: category});
    };
    handleCategory = (category: string) =>{
        if(category){
            TgccRequest.getDesignsByCategoryFiltered(DIVISION, category, null, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))
        }
        this.setState({category: category});
        if(this.state.isWaiting === false){
            this.setState({isWaiting:true})
        }else {
            this.setState({isWaiting:false});
        }
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: category});
    };

    clearCategory = () =>{
        this.setState({category:null});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: null})
    }

    DesignsLoaded(Designs : Tgcc.Design[]) {
        for(var i in Designs)
            Designs[i].displayIndex = Number(i);
        this.setState({Designs: Designs,isWaiting:false});
    }

    DesignsVisible: boolean = false;
    getDesignItems() {
        this.DesignsVisible = false;
       
        var Designs = new Array();
        var noItemsStyle = { fontFamily: 'AveriaSerifLight', fontSize:'24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center',color:'rgb(166, 166, 166)'};

        if(this.state.Designs){
            if(this.state.Designs.length == 0){
                Designs.push( <div key="none" style={noItemsStyle}>No matching items</div>);
            } 

            for(var i in this.state.Designs){
                var design: Tgcc.Design = this.state.Designs[i];
                Designs.push(<CampusDesignCard key={design.id} design={design} onSelect={this.handleDesignSelection} onZoom={this.handleZoom}/>);
            }
            this.DesignsVisible = true;
        } else {
            var chooseSomething = (<div key="none" style={noItemsStyle}>Select a category or search</div>);
            Designs.push(chooseSomething);
        }

        return Designs;
        
    }

    getBackButton(){
        var style : CSSProperties = {
            fontSize: '14px',
            letterSpacing: '3px',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginTop: '10px',
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid tranparent',
            width: '40%',
            cursor: 'pointer',
        };
        return ( <div className="hoverBorder" style={style} onClick={this.handleBackToProof}>back</div>)
    }

    handleBackToProof = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None})
    }

    handleZoom = (design: Tgcc.Design) => {
        this.setState({zoomDesign:design});
    }

    handleDesignSelection = (design : Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofDesign, payload: design});
    }

    selectedImageStyle: CSSProperties = {
         display: 'flex',
         width: '200px',
         alignSelf: 'center',
         cursor: 'zoom-in'
    }


    handleDetailBackButton = () => {
        this.setState( { design: null});
    }

    handleTextSearch = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.keyCode == 13){ // return keyCode
            this.filterDesignsBySearch(evt.currentTarget.value.toLowerCase());
        }

        var style = evt.currentTarget.attributes['style'];
        if(style && style.value){
            if(evt.currentTarget.value)
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 6px','letter-spacing: 1px');
            else
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 1px','letter-spacing: 6px');
        }
    }

    handleTextSearchBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
        var srch = evt.currentTarget as HTMLInputElement;
        var srchComp = !srch.value ? null : srch.value.toLowerCase(); // make sure "" is set to null
        if(this.state.filter != srchComp){
            this.filterDesignsBySearch(srch.value);
        }
    }

    filterDesignsBySearch(filter: string){
        filter = filter && filter.length ? filter : null;
        this.setState({filter: filter, Designs: null, category:null});
        this.clearCategory();
        TgccRequest.getAllDesignsBySearchFilter( filter, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs));

    }
    onSubmit(e){
        e.preventDefault();
    }

    get = () => {
        if(this.state.filter) {
            this.filterDesignsBySearch(this.state.filter.toLowerCase());
        }
    }

    mobileCheck() {
        return (<div style={inputDiv}><input type="text" id="search" ref="searchCategory" style={searchStyle} placeholder="Search Everything" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch}/></div>)
    }
    render() {

        var categories = this.state.DesignCategories ? this.getDesignCategories() : <Tgcc.LoadingElement />
        var searchBlock = this.mobileCheck();
        var designs = this.state.isWaiting ? <Tgcc.LoadingElement /> : this.getDesignItems() 
        return (
                    <div key="1">

                    <div id='designPage'></div>
                        <MajorAccountsHdr />
                        <CampusFeedback state={this.props.state} />

                        <div style={designHdr}>Pick a design to add to your proof</div>
                        {searchBlock}
                        <div onClick={this.get} className="srchBtnCampus" style={submitButton}>Submit</div>      

                        <div style={contentDiv} className="campusDesign2Box">
                        <div style={smHeadStyle} className="campusDesignHdr">
                            <h3>CATEGORIES</h3>
                        </div>    
                        <div key="2" style={categoryContainerStyle} className="campusCatCont">
                                <div style={categoryListStyle} className="campusCatList">{categories}</div>
                            </div>
                            <div style={catalogStyle} className="campusLogStyle">
                                {designs}
                           </div>
                            {this.getZoomedDesign()}
                            </div>
                          <MajorAccountsFooter state={this.props.state}/>
                       </div>
                )
    }



    getZoomedDesign = () =>  {
        if(!this.state.zoomDesign)
            return (<a/>);

       let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center',
            width: '600px',
            height: '800px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            }
           
       };

        let imgStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '80%',
            maxHeight: '75%',
            display: 'block',
            alignSelf: 'center',
            cursor: 'zoom-out'
        };

        let screenDoor: CSSProperties = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22,22,22,0.5)',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden'
        }        
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
        }
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }
        var largeImage = Tgcc.getDesignPath(this.state.zoomDesign.image);
        return ( 
            <ScreenDoor>
                <div style={fullSizeStyle} className="fullSizeStyle">
                    <CloseX closeAction={this.hideZoom} />
                    <img src={largeImage} style={imgStyle} onError={Tgcc.handleDesignImageError} onClick={this.hideZoom}/> 
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.handlePrev}>&lsaquo;</div>
                        <div className="grayButton" style={addToProofBtn} onClick={this.handleZoomAdd}>add to proof</div>
                        <div style={arrowStyle} onClick={this.handleNext}>&rsaquo;</div>
                    </div>  
                </div>
            </ScreenDoor>
        )
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    hideZoom = () => {
        this.setState({zoomDesign: null});
    }

    handleZoomAdd = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        if(this.props.state.LoginData && this.props.state.UserInfo){
            this.handleDesignSelection(this.state.zoomDesign);
        } else
        {
            browserHistory.push(Tgcc.Routes.Register)
        }
    }

    handlePrev = (evt: React.MouseEvent<HTMLDivElement>) =>{
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex-1;
        curIndex = curIndex < 0 ? this.state.Designs.length - 1 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }

    handleNext = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex+1;
        curIndex = curIndex >= this.state.Designs.length ? 0 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }
}
  
const mapStateToProps = (state : Tgcc.GlobalState ) => {
    return {state:state}
};

export var MajorAccountsDesignListView = connect(mapStateToProps)(Radium(_MajorAccountsDesignListView));